import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const PortalContainer = ({ children, className = '', element = 'div', isCheckModalOpened = true }) => {
  const [container] = useState(() => {
    const el = document.createElement(element);
    el.classList.add(className);
    return el;
  });

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container, isCheckModalOpened]);

  return createPortal(children, container);
};

export default PortalContainer;
